import { cfV2ActionTypes } from '@Actions/configurations/cfV2Actions';

const CFV2Reducers = (state = {}, action) => {
  switch (action.type) {
  case cfV2ActionTypes.GET_CFV2.LOADING: {
    const { getCFV2Loading, entityType } = action;

    if (entityType === 'PRODUCTS') {
      return {
        ...state,
        getCFV2ProductsLoading: getCFV2Loading,
      };
    }
    if (entityType === 'VENDORS') {
      return {
        ...state,
        getCFV2VendorsLoading: getCFV2Loading,
      };
    }
    if (entityType === 'DELIVERY_CHALLAN') {
      return {
        ...state,
        getCFV2DeliveryChallanLoading: getCFV2Loading,
      };
    }
    if (entityType === 'STOCK_ADJUSTMENT') {
      return {
        ...state,
        getCFV2StockAdjustmentLoading: getCFV2Loading,
      };
    }
    if (entityType === 'BILL_OF_MATERIAL') {
      return {
        ...state,
        getCFV2BillOfMaterialLoading: getCFV2Loading,
      };
    }
    if (entityType === 'STOCK_TRANSFER') {
      return {
        ...state,
        getCFV2StockTransferLoading: getCFV2Loading,
      };
    }
    if (entityType === 'CUSTOMER_PAYMENT') {
      return {
        ...state,
        getCFV2customerPaymentLoading: getCFV2Loading,
      };
    }

    if (entityType === 'VENDOR_PAYOUT') {
      return {
        ...state,
        getCFV2VendorPayoutLoading: getCFV2Loading,
      };
    }
    if (entityType === 'SALES_ESTIMATE') {
      return {
        ...state,
        getCFV2SalesEstimateLoading: getCFV2Loading,
      };
    }
    if (entityType === 'SALES_ORDER') {
      return {
        ...state,
        getCFV2SalesOrderLoading: getCFV2Loading,
      };
    }
    if (entityType === 'ANNUAL_MAINTENANCE_CONTRACT') {
      return {
        ...state,
        getCFV2AnnualContractMaintenanceLoading: getCFV2Loading,
      };
    }
    if (entityType === 'PACKING_SLIP') {
      return {
        ...state,
        getCFV2PackingSlipLoading: getCFV2Loading,
      };
    }
    if (entityType === 'GATE_DOCUMENT') {
      return {
        ...state,
        getCFV2GateDocumentLoading: getCFV2Loading,
      };
    }
    if (entityType === 'MANUFACTURING_ORDER') {
      return {
        ...state,
        getCFV2ManufacturingOrderLoading: getCFV2Loading,
      };
    }
    if (entityType === 'DEBIT_NOTE') {
      return {
        ...state,
        getCFV2DebitNoteLoading: getCFV2Loading,
      };
    }
    if (entityType === 'GOOD_RECEIVING_NOTES') {
      return {
        ...state,
        getCFV2GoodReceivingNotesLoading: getCFV2Loading,
      };
    }
    if (entityType === 'ACCOUNT_PAYABLE_INVOICE') {
      return {
        ...state,
        getCFV2APInvoiceLoading: getCFV2Loading,
      };
    }
    if (entityType === 'PURCHASE_ORDERS') {
      return {
        ...state,
        getCFV2PurchaseOrdersLoading: getCFV2Loading,
      };
    }
    if (entityType === 'PURCHASE_REQUEST') {
      return {
        ...state,
        getCFV2PurchaseRequestLoading: getCFV2Loading,
      };
    }
    if (entityType === 'PURCHASE_INDENT') {
      return {
        ...state,
        getCFV2PurchaseIndentLoading: getCFV2Loading,
      };
    }
    if (entityType === 'CREDIT_NOTE') {
      return {
        ...state,
        getCFV2CreditNoteLoading: getCFV2Loading,
      };
    }
    if (entityType === 'RETURN_SLIP') {
      return {
        ...state,
        getCFV2ReturnSlipLoading: getCFV2Loading,
      };
    }
    if (entityType === 'CUSTOMERS') {
      return {
        ...state,
        getCFV2customersLoading: getCFV2Loading,
      };
    }
    if (entityType === 'INVOICE') {
      return {
        ...state,
        getCFV2InvoiceLoading: getCFV2Loading,
      };
    }
    if (entityType === 'CONSUMPTION_ORDER') {
      return {
        ...state,
        getDocCFV2ConsumptionLoading: getCFV2Loading,
      };
    }
    if (entityType === 'BATCH') {
      return {
        ...state,
        getCFV2BatchLoading: getCFV2Loading,
      };
    }
    if (entityType === 'EXPENSE') {
      return {
        ...state,
        getCFV2ExpenseLoading: getCFV2Loading,
      };
    }
    if (entityType === 'IN_PROCESS_QUALITY_CONTROL_RULE') {
      return {
        ...state,
        getCFV2InProcessQCLoading: getCFV2Loading,
      };
    }
    if (entityType === 'PRE_DISPATCH_INSPECTION_RULE') {
      return {
        ...state,
        getCFV2PDIRuleLoading: getCFV2Loading,
      };
    }
    if (entityType === 'EXPORT_INVOICE') {
      return {
        ...state,
        getCFV2ExportInvoiceLoading: getCFV2Loading,
      };
    }
    if (entityType === 'EXPORT_PACKING_SLIP') {
      return {
        ...state,
        getCFV2ExportPackingSlipLoading: getCFV2Loading,
      };
    }
    return {
      ...state,
      globalCfV2Loading: getCFV2Loading,
    };
  }

  case cfV2ActionTypes.GET_CFV2.SUCCESS: {
    const { customFieldsV2, entityType } = action;

    if (entityType === 'PRODUCTS') {
      return {
        ...state,
        cfV2Products: customFieldsV2,
      };
    }
    if (entityType === 'VENDORS') {
      return {
        ...state,
        cfV2Vendors: customFieldsV2,
      };
    }
    if (entityType === 'DELIVERY_CHALLAN') {
      return {
        ...state,
        cfV2DeliveryChallan: customFieldsV2,
      };
    }
    if (entityType === 'STOCK_ADJUSTMENT') {
      return {
        ...state,
        cfV2StockAdjustment: customFieldsV2,
      };
    }
    if (entityType === 'BILL_OF_MATERIAL') {
      return {
        ...state,
        cfV2BillOfMaterial: customFieldsV2,
      };
    }
    if (entityType === 'STOCK_TRANSFER') {
      return {
        ...state,
        cfV2StockTransfer: customFieldsV2,
      };
    }
    if (entityType === 'CUSTOMERS_PAYMENT') {
      return {
        ...state,
        cfV2customerPayment: customFieldsV2,
      };
    }
    if (entityType === 'VENDOR_PAYOUT') {
      return {
        ...state,
        cfV2VendorPayout: customFieldsV2,
      };
    }
    if (entityType === 'SALES_ESTIMATE') {
      return {
        ...state,
        cfV2SalesEstimate: customFieldsV2,
      };
    }
    if (entityType === 'SALES_ORDER') {
      return {
        ...state,
        cfV2SalesOrder: customFieldsV2,
      };
    }
    if (entityType === 'ANNUAL_MAINTENANCE_CONTRACT') {
      return {
        ...state,
        cfV2AnnualMaintenanceContract: customFieldsV2,
      };
    }
    if (entityType === 'PACKING_SLIP') {
      return {
        ...state,
        cfV2PackingSlip: customFieldsV2,
      };
    }
    if (entityType === 'GATE_DOCUMENT') {
      return {
        ...state,
        cfV2GateDocument: customFieldsV2,
      };
    }
    if (entityType === 'MANUFACTURING_ORDER') {
      return {
        ...state,
        cfV2ManufacturingOrder: customFieldsV2,
      };
    }
    if (entityType === 'DEBIT_NOTE') {
      return {
        ...state,
        cfV2DebitNote: customFieldsV2,
      };
    }
    if (entityType === 'GOOD_RECEIVING_NOTES') {
      return {
        ...state,
        cfV2GoodReceivingNotes: customFieldsV2,
      };
    }
    if (entityType === 'ACCOUNT_PAYABLE_INVOICE') {
      return {
        ...state,
        cfV2APInvoice: customFieldsV2,
      };
    }
    if (entityType === 'PURCHASE_ORDERS') {
      return {
        ...state,
        cfV2PurchaseOrders: customFieldsV2,
      };
    }
    if (entityType === 'PURCHASE_REQUEST') {
      return {
        ...state,
        cfV2PurchaseRequest: customFieldsV2,
      };
    }
    if (entityType === 'PURCHASE_INDENT') {
      return {
        ...state,
        cfV2PurchaseIndent: customFieldsV2,
      };
    }
    if (entityType === 'CREDIT_NOTE') {
      return {
        ...state,
        cfV2CreditNote: customFieldsV2,
      };
    }
    if (entityType === 'RETURN_SLIP') {
      return {
        ...state,
        cfV2ReturnSlip: customFieldsV2,
      };
    }
    if (entityType === 'CUSTOMERS') {
      return {
        ...state,
        cfV2customers: customFieldsV2,
      };
    }
    if (entityType === 'INVOICE') {
      return {
        ...state,
        cfV2Invoice: customFieldsV2,
      };
    }
    if (entityType === 'CONSUMPTION_ORDER') {
      return {
        ...state,
        cfV2DocConsumption: customFieldsV2,
      };
    }
    if (entityType === 'BATCH') {
      return {
        ...state,
        cfV2Batch: customFieldsV2,
      };
    }
    if (entityType === 'EXPENSE') {
      return {
        ...state,
        cfV2Expense: customFieldsV2,
      };
    }
    if (entityType === 'IN_PROCESS_QUALITY_CONTROL_RULE') {
      return {
        ...state,
        cfV2InProcessQC: customFieldsV2,
      };
    }
    if (entityType === 'PRE_DISPATCH_INSPECTION_RULE') {
      return {
        ...state,
        cfV2PDIRule: customFieldsV2,
      };
    }
    if (entityType === 'EXPORT_INVOICE') {
      return {
        ...state,
        cfV2ExportInvoice: customFieldsV2,
      };
    }
    if (entityType === 'EXPORT_PACKING_SLIP') {
      return {
        ...state,
        cfV2ExportPackingSlip: customFieldsV2,
      };
    }
    return {
      ...state,
      globalCfV2: customFieldsV2,
    };
  }

  case cfV2ActionTypes.UPDATE_CFV2.LOADING: {
    const { updateCFV2Loading } = action;
    return {
      ...state,
      updateCFV2Loading,
    };
  }

  case cfV2ActionTypes.GET_CFV2_GLOBAL.SUCCESS: {
    const { cfGlobal } = action;
    return {
      ...state,
      cfGlobal,
    };
  }

  case cfV2ActionTypes.CREATE_CFV2.LOADING: {
    const { createCFV2Loading } = action;
    return {
      ...state,
      createCFV2Loading,
    };
  }

  case cfV2ActionTypes.GET_DOC_CFV2.LOADING: {
    const { getDocCFV2Loading, entityName } = action;

    if (entityName === 'PRODUCTS') {
      return {
        ...state,
        getDocCFV2ProductsLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'VENDORS') {
      return {
        ...state,
        getDocCFV2VendorsLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'DELIVERY_CHALLAN') {
      return {
        ...state,
        getDocCFV2DeliveryChallanLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'STOCK_ADJUSTMENT') {
      return {
        ...state,
        getDocCFV2StockAdjustmentLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'BILL_OF_MATERIAL') {
      return {
        ...state,
        getDocCFV2BillOfMaterialLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'STOCK_TRANSFER') {
      return {
        ...state,
        getDocCFV2StockTransferLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'CUSTOMER_PAYMENT') {
      return {
        ...state,
        getDocCFV2customerPaymentLoading: getDocCFV2Loading,
      };
    }

    if (entityName === 'VENDOR_PAYOUT') {
      return {
        ...state,
        getDocCFV2VendorPayoutLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'SALES_ESTIMATE') {
      return {
        ...state,
        getDocCFV2SalesEstimateLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'SALES_ORDER') {
      return {
        ...state,
        getDocCFV2SalesOrderLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'ANNUAL_MAINTENANCE_CONTRACT') {
      return {
        ...state,
        getDocCFV2AnnualContractMaintenanceLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'PACKING_SLIP') {
      return {
        ...state,
        getDocCFV2PackingSlipLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'GATE_DOCUMENT') {
      return {
        ...state,
        getCFV2GateDocumentLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'MANUFACTURING_ORDER') {
      return {
        ...state,
        getDocCFV2ManufacturingOrderLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'DEBIT_NOTE') {
      return {
        ...state,
        getDocCFV2DebitNoteLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'GOOD_RECEIVING_NOTES') {
      return {
        ...state,
        getDocCFV2GoodReceivingNotesLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'ACCOUNT_PAYABLE_INVOICE') {
      return {
        ...state,
        getDocCFV2APInvoiceLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'PURCHASE_ORDERS') {
      return {
        ...state,
        getDocCFV2PurchaseOrdersLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'PURCHASE_REQUEST') {
      return {
        ...state,
        getDocCFV2PurchaseRequestLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'PURCHASE_INDENT') {
      return {
        ...state,
        getDocCFV2PurchaseIndentLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'CREDIT_NOTE') {
      return {
        ...state,
        getDocCFV2CreditNoteLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'RETURN_SLIP') {
      return {
        ...state,
        getDocCFV2ReturnSlipLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'CUSTOMERS') {
      return {
        ...state,
        getDocCFV2customersLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'INVOICE') {
      return {
        ...state,
        getDocCFV2InvoiceLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'CONSUMPTION_ORDER') {
      return {
        ...state,
        getDocCFV2ConsumptionLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'EXPENSE') {
      return {
        ...state,
        getDocCFV2ExpenseLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'IN_PROCESS_QUALITY_CONTROL_RULE') {
      return {
        ...state,
        getDocCFV2InProcessQCLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'PRE_DISPATCH_INSPECTION_RULE') {
      return {
        ...state,
        getDocCFV2PDIRuleLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'EXPORT_INVOICE') {
      return {
        ...state,
        getDocCFV2ExportInvoiceLoading: getDocCFV2Loading,
      };
    }
    if (entityName === 'EXPORT_PACKING_SLIP') {
      return {
        ...state,
        getDocCFV2ExportPackingSlipLoading: getDocCFV2Loading,
      };
    }
    return {
      ...state,
      getDocCFV2GlobalLoading: getDocCFV2Loading,
    };
  }

  case cfV2ActionTypes.GET_DOC_CFV2.SUCCESS: {
    const { customFieldsDocV2, entityName } = action;

    if (entityName === 'PRODUCTS') {
      return {
        ...state,
        cfV2DocProducts: customFieldsDocV2,
      };
    }
    if (entityName === 'VENDORS') {
      return {
        ...state,
        cfV2DocVendors: customFieldsDocV2,
      };
    }
    if (entityName === 'DELIVERY_CHALLAN') {
      return {
        ...state,
        cfV2DocDeliveryChallan: customFieldsDocV2,
      };
    }
    if (entityName === 'STOCK_ADJUSTMENT') {
      return {
        ...state,
        cfV2DocStockAdjustment: customFieldsDocV2,
      };
    }
    if (entityName === 'BILL_OF_MATERIAL') {
      return {
        ...state,
        cfV2DocBillOfMaterial: customFieldsDocV2,
      };
    }
    if (entityName === 'STOCK_TRANSFER') {
      return {
        ...state,
        cfV2DocStockTransfer: customFieldsDocV2,
      };
    }
    if (entityName === 'CUSTOMERS_PAYMENT') {
      return {
        ...state,
        cfV2DoccustomerPayment: customFieldsDocV2,
      };
    }
    if (entityName === 'VENDOR_PAYOUT') {
      return {
        ...state,
        cfV2DocVendorPayout: customFieldsDocV2,
      };
    }
    if (entityName === 'SALES_ESTIMATE') {
      return {
        ...state,
        cfV2DocSalesEstimate: customFieldsDocV2,
      };
    }
    if (entityName === 'SALES_ORDER') {
      return {
        ...state,
        cfV2DocSalesOrder: customFieldsDocV2,
      };
    }
    if (entityName === 'ANNUAL_MAINTENANCE_CONTRACT') {
      return {
        ...state,
        cfV2DocAnnualMaintenanceContract: customFieldsDocV2,
      };
    }
    if (entityName === 'PACKING_SLIP') {
      return {
        ...state,
        cfV2DocPackingSlip: customFieldsDocV2,
      };
    }
    if (entityName === 'GATE_DOCUMENT') {
      return {
        ...state,
        cfV2DocGateDocument: customFieldsDocV2,
      };
    }
    if (entityName === 'MANUFACTURING_ORDER') {
      return {
        ...state,
        cfV2DocManufacturingOrder: customFieldsDocV2,
      };
    }
    if (entityName === 'DEBIT_NOTE') {
      return {
        ...state,
        cfV2DocDebitNote: customFieldsDocV2,
      };
    }
    if (entityName === 'GOOD_RECEIVING_NOTES') {
      return {
        ...state,
        cfV2DocGoodReceivingNotes: customFieldsDocV2,
      };
    }
    if (entityName === 'ACCOUNT_PAYABLE_INVOICE') {
      return {
        ...state,
        cfV2DocAPInvoice: customFieldsDocV2,
      };
    }
    if (entityName === 'PURCHASE_ORDERS') {
      return {
        ...state,
        cfV2DocPurchaseOrders: customFieldsDocV2,
      };
    }
    if (entityName === 'PURCHASE_REQUEST') {
      return {
        ...state,
        cfV2DocPurchaseRequest: customFieldsDocV2,
      };
    }
    if (entityName === 'PURCHASE_INDENT') {
      return {
        ...state,
        cfV2DocPurchaseIndent: customFieldsDocV2,
      };
    }
    if (entityName === 'CREDIT_NOTE') {
      return {
        ...state,
        cfV2DocCreditNote: customFieldsDocV2,
      };
    }
    if (entityName === 'RETURN_SLIP') {
      return {
        ...state,
        cfV2DocReturnSlip: customFieldsDocV2,
      };
    }
    if (entityName === 'CUSTOMERS') {
      return {
        ...state,
        cfV2DocCustomers: customFieldsDocV2,
      };
    }
    if (entityName === 'INVOICE') {
      return {
        ...state,
        cfV2DocInvoice: customFieldsDocV2,
      };
    }
    if (entityName === 'CONSUMPTION_ORDER') {
      return {
        ...state,
        cfV2DocConsumption: customFieldsDocV2,
      };
    }

    if (entityName === 'EXPENSE') {
      return {
        ...state,
        cfV2DocExpense: customFieldsDocV2,
      };
    }
    if (entityName === 'IN_PROCESS_QUALITY_CONTROL_RULE') {
      return {
        ...state,
        cfV2DocInProcessQC: customFieldsDocV2,
      };
    }
    if (entityName === 'PRE_DISPATCH_INSPECTION_RULE') {
      return {
        ...state,
        cfV2DocPDIRule: customFieldsDocV2,
      };
    }
    if (entityName === 'EXPORT_INVOICE') {
      return {
        ...state,
        cfV2DocExportInvoice: customFieldsDocV2,
      };
    }
    if (entityName === 'EXPORT_PACKING_SLIP') {
      return {
        ...state,
        cfV2DocExportPackingSlip: customFieldsDocV2,
      };
    }
    return {
      ...state,
      globalCfV2Doc: customFieldsDocV2,
    };
  }

  default: {
    return state;
  }
  }
};

export default CFV2Reducers;